import { OperationImportContextModel } from '../operation-import-context-model';

export class MicrosoftOfficeOperationStopPermanentAuditContextModel extends OperationImportContextModel {
}
